import { MinLength, UppercaseCount, LowercaseCount, SpecialCharactersCount, DigitsCount } from './rules';

export const DefaultRuleset = [
    new MinLength(12),
    new UppercaseCount(1),
    new LowercaseCount(1),
    new SpecialCharactersCount(1),
    new DigitsCount(1)
];
